/**
 *
 */
(function() {
    'use strict';
    angular.module('cbl.insuranceloanpmi.mf').factory('CreasMessaggiFctr', [
        'CblMessageSrvc',
        'LabelSrvc',
        'LoggerSrvc',
        'CommonUtilitiesSrvc',
        '$uibModal',
        function(messaggiSrvc, labelSrvc, loggerSrvc, commonUtilities, $uibModal) {
            var processaResponse = function(response) {
                if (!response) {
                    var message = {
                        message: 'Nessuna risposta ricevuta dal servizio'
                    };
                    messaggiSrvc.pushErrorMessage(message.message);
                    return true;
                }
                var hasError = false;
                if (response.data && response.data.messageList) {
                    if (response.data.messageList.errMessages) {
                        for (var i in response.data.messageList.errMessages) {
                            messaggiSrvc.pushErrorMessage(
                                response.data.messageList.errMessages[i].message
                            );
                            console.error(response.data.messageList.errMessages[i].message);
                        }
                        hasError = response.data.messageList.errMessages.length > 0;
                    }
                    if (response.data.messageList.fatMessages) {
                        for (var j in response.data.messageList.fatMessages) {
                            messaggiSrvc.pushErrorMessage(
                                response.data.messageList.fatMessages[j].message
                            );
                            console.error(response.data.messageList.fatMessages[i].message);
                        }

                        if (hasError === false) {
                            hasError = response.data.messageList.fatMessages.length > 0;
                        }
                    }
                    if (response.data.messageList.warMessages) {
                        for (var k in response.data.messageList.warMessages) {
                            messaggiSrvc.pushWarningMessage(
                                response.data.messageList.warMessages[k].message
                            );
                        }
                    }
                    if (response.data.messageList.infMessages) {
                        for (var z in response.data.messageList.infMessages) {
                            messaggiSrvc.pushInfoMessage(
                                response.data.messageList.infMessages[z].message
                            );
                        }
                    }
                }
                if (response.status === 504) {
                    messaggiSrvc.pushErrorMessage(
                        labelSrvc.getLabel('errors.gatewaytimeout')
                    );
                    return true;
                }
                if (response.status > 399) {
                    if (typeof response.data === 'string') {
                        try {
                            var businessParam = JSON.parse(response.data).Messages[0]
                                .BusinessParam;
                            var businessParamType = commonUtilities.isNullOrUndefined(
                                    businessParam
                                ) ?
                                null :
                                businessParam.Type;
                            if (businessParamType == 'DOCUMENTI_INCOMPLETI_OBBLIGATORI') {
                                commonUtilities.showPopupObligatoryDocumentsIncomplete({ $uibModal: $uibModal },
                                    response,
                                    null
                                );
                            } else if (businessParamType == 'CAMBIO_STATO_BLOCCATO') {
                                commonUtilities.showPopupChangeStateBlocked({ $uibModal: $uibModal },
                                    response,
                                    null
                                );
                            } else {
                                var errorMsg = JSON.parse(response.data);

                                if (errorMsg && errorMsg.Messages) {
                                    for (var i = 0; i < errorMsg.Messages.length; i++) {
                                        messaggiSrvc.pushErrorMessage(errorMsg.Messages[i].Message);
                                    }
                                }
                            }
                        } catch (e) {}
                    } else {
                        var messageHttp = {
                            message: 'Error ' + response.status + ' ' + response.statusText
                        };
                        messaggiSrvc.pushErrorMessage(messageHttp.message);
                    }
                    return true;
                }
                return hasError;
            };

            var addMessage = function(message) {
                if (message.type === 'E' || message.type === 'F') {
                    messaggiSrvc.pushErrorMessage(message.message);
                } else if (message.type === 'W') {
                    messaggiSrvc.pushWarningMessage(message.message);
                } else {
                    messaggiSrvc.pushInfoMessage(message.message);
                }
            };

            var resetMessages = function() {
                messaggiSrvc.reset();
            };

            var processaForm = function(form) {
                if (form.$valid) {
                    return true;
                }
                this.validaForm(form);
                var message = null;
                for (var label in form.$error.required) {
                    message = {
                        type: 'E',
                        message: form.$error.required[label].$name +
                            ': ' +
                            labelSrvc.getLabel('validazione.obbligatorio')
                    };
                    this.addMessage(message);
                }
                for (var labelMax in form.$error.max) {
                    message = {
                        type: 'E',
                        message: form.$error.max[labelMax].$name +
                            ': ' +
                            labelSrvc.getLabel('validazione.valore.massimo')
                    };
                    this.addMessage(message);
                }
                for (var labelNmb in form.$error.number) {
                    message = {
                        type: 'E',
                        message: form.$error.number[labelNmb].$name +
                            ': ' +
                            labelSrvc.getLabel('validazione.numerico')
                    };
                    this.addMessage(message);
                }
                for (var labelMin in form.$error.min) {
                    message = {
                        type: 'E',
                        message: form.$error.number[labelMin].$name +
                            ': ' +
                            labelSrvc.getLabel('validazione.valore.minimo')
                    };
                    this.addMessage(message);
                }
                return false;
            };

            var validaForm = function(form) {
                this.resetMessages();
                var valid = true;
                var message = null;
                var label = null;
                for (label in form.$error.pattern) {
                    valid = false;
                    message = {
                        type: 'E',
                        message: form.$error.pattern[label].$name +
                            ': ' +
                            labelSrvc.getLabel('validazione.formato')
                    };
                    this.addMessage(message);
                }
                for (label in form.$error.cblMax) {
                    valid = false;
                    message = {
                        type: 'E',
                        message: form.$error.cblMax[label].$name +
                            ': ' +
                            labelSrvc.getLabel('validazione.massimo')
                    };
                    this.addMessage(message);
                }
                for (label in form.$error.cblMin) {
                    valid = false;
                    message = {
                        type: 'E',
                        message: form.$error.cblMin[label].$name +
                            ': ' +
                            labelSrvc.getLabel('validazione.minimo')
                    };
                    this.addMessage(message);
                }
                for (label in form.$error.cblPrecisione) {
                    valid = false;
                    message = {
                        type: 'E',
                        message: form.$error.cblPrecisione[label].$name +
                            ': ' +
                            labelSrvc.getLabel('validazione.precisione')
                    };
                    this.addMessage(message);
                }
                for (label in form.$error.maxlength) {
                    valid = false;
                    message = {
                        type: 'E',
                        message: form.$error.maxlength[label].$name +
                            ': ' +
                            labelSrvc.getLabel('validazione.maxlength')
                    };
                    this.addMessage(message);
                }
                for (label in form.$error.minlength) {
                    valid = false;
                    message = {
                        type: 'E',
                        message: form.$error.minlength[label].$name +
                            ': ' +
                            labelSrvc.getLabel('validazione.minlength')
                    };
                    this.addMessage(message);
                }
                for (label in form.$error.maxDate) {
                    valid = false;
                    message = {
                        type: 'E',
                        message: form.$error.maxDate[label].$name +
                            ': ' +
                            labelSrvc.getLabel('validazione.maxdate')
                    };
                    this.addMessage(message);
                }
                for (label in form.$error.minDate) {
                    valid = false;
                    message = {
                        type: 'E',
                        message: form.$error.minDate[label].$name +
                            ': ' +
                            labelSrvc.getLabel('validazione.mindate')
                    };
                    this.addMessage(message);
                }
                return valid;
            };

            var scroll = function(id) {
                var headerMarg = parseInt(
                    angular.element('.navbar-fixed-top').css('margin-top')
                );
                if (isNaN(headerMarg)) {
                    headerMarg = 0;
                }
                var diffScroll =
                    angular.element('.navbar-fixed-top').height() +
                    headerMarg +
                    angular.element('#prodConvBox').height();
                var scrollPoint = angular.element(id).offset().top - diffScroll;
                angular.element('body,html').animate({
                        scrollTop: scrollPoint
                    },
                    500
                );
            };

            return {
                processaResponse: processaResponse,
                addMessage: addMessage,
                resetMessages: resetMessages,
                processaForm: processaForm,
                validaForm: validaForm,
                scroll: scroll
            };
        }
    ]);
})();


//////////////////
// WEBPACK FOOTER
// ./app/components/servicesUtilities/messaggiFctr.js
// module id = 33
// module chunks = 0 1